import { useState } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Button, Modal } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

export const useDiscardChangesModal = (onSubmit: () => void) => {
    const [isOpen, setOpen] = useState<boolean>(false);

    const closeModal = (): void => {
        setOpen(false);
    };

    const submit = (): void => {
        onSubmit();
        closeModal();
    };

    return {
        openModal: () => setOpen(true),
        modal: (
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                shouldCloseOnEsc
                shouldCloseOnOverlayClick
                customStyles={{
                    content: {
                        width: "400px",
                    },
                }}
            >
                <Modal.Header>
                    <Modal.Title tooltip={translate("llm.setup.close.modal.tooltip")}>
                        {translate("llm.setup.close.modal.title")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Content>
                    <Text
                        fontVariant="body1"
                        color={colorsPalettes.carbon[400]}
                        padding="16px 0 8px"
                    >
                        {translate("llm.setup.close.modal.text")}
                    </Text>
                </Modal.Content>
                <Modal.Footer>
                    <Button
                        type="flat"
                        onClick={closeModal}
                    >
                        {translate("global.cancel")}
                    </Button>
                    <Button
                        type="warning"
                        onClick={submit}
                    >
                        {translate("common.discard")}
                    </Button>
                </Modal.Footer>
            </Modal>
        ),
    };
};
